export const AFV_PERMISSIONS = {
	changeOrderPrint: 'afv.changeOrderPrint',
	editSentOrders: 'afv.editSentOrders',
	allowChangeUnitPrice: 'afv.allowChangeUnitPrice',
	allowBypassMinimumPrice: 'afv.allowBypassMinimumPrice',
	restrictPriceLists: 'afv.restrictPriceLists',
	restrictBrands: 'afv.restrictBrands',
	showSellerPortfolioOnly: 'afv.showSellerPortfolioOnly',
	viewClientsWithoutSeller: 'afv.viewClientsWithoutSeller',
} as const;

export type TAfvPermission =
	typeof AFV_PERMISSIONS[keyof typeof AFV_PERMISSIONS];
